import React, { useEffect, useRef, useState } from 'react';
import Header from '../../directives/header';
import Footer from '../../directives/footer';
import Sidebar from '../../directives/sidebar';
import toast, { Toaster } from 'react-hot-toast';
import JoditEditor from 'jodit-react';
import { getAllCms, updateCms } from "../../Action/action";

const GoverningLaw = () => {
  const editor = useRef(null);

  const [governingLaw, setGoverningLawId] = useState(null);
  const [governingLawContent, setGoverningLawContent] = useState('');

  useEffect(() => {
	getCmsDetail();
  }, []);

  const getCmsDetail = async () => {
	try {
	  const res = await getAllCms();
	  if (res.status) {
		setGoverningLawId(res.data._id);
		setGoverningLawContent(res.data.governingLaw);
	  }
	} catch (err) {
	  toast.error("Failed to fetch Governing Law");
	}
  };

  const handleUpdate = async () => {
	if (!governingLaw) {
	  toast.error("Governing Law ID missing");
	  return;
	}

	try {
	  const res = await updateCms({
		_id: governingLaw,
		governingLaw: governingLawContent,
		governingLawUpdatedAt:new Date()
	  });

	  if (res.status) {
		toast.success('Governing Law updated successfully!');
		getCmsDetail(); // refresh data
	  }
	} catch (error) {
	  toast.error(error.message || "Failed to update Governing Law");
	}
  };

  return (
	<div className="wrapper h-auto">
	  <Header />
	  <Toaster />
	  <Sidebar />

	  <div className="content-wrapper">
		<div className="container-full">
		  <section className="content">
			<div className="row">
			  <div className="col-lg-12 col-12 p-4">
				<div className="box">
				  <div className="box-header with-border">
					<h3 className="box-title" style={{ fontWeight: 600 }}>
					  Governing Law
					</h3>
				  </div>

				  <div className="row mt-20 mb-50">
					<div className="col-md-12">
					  <div className="form-group row mb-3 px-15">
						<label className="col-form-label">
						  Governing Law Content
						</label>

						<JoditEditor
						  ref={editor}
						  value={governingLawContent}
						  tabIndex={1}
						  onBlur={(newContent) =>
							setGoverningLawContent(newContent)
						  }
						/>
					  </div>

					  <div className="text-start px-15">
						<button
						  type="button"
						  className="btn btn-primary"
						  onClick={handleUpdate}
						>
						  Update
						</button>
					  </div>

					</div>
				  </div>

				</div>
			  </div>
			</div>
		  </section>
		</div>
	  </div>

	  <Footer />
	</div>
  );
};

export default GoverningLaw;
